import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'HospitalInfo/Login',
    method: 'post',
    data
  })
}

export function addUser(data) {
  return request({
    url: 'PersonnelInfo/AddPersonnelInfo',
    method: 'post',
    data
  })
}

export function searchUser(data) {
  return request({
    url: 'PersonnelInfo/GetPersonnelInfobyPhone',
    method: 'post',
    data
  })
}

export function editUser(data) {
  return request({
    url: 'PersonnelInfo/UpdatePersonnelInfo',
    method: 'post',
    data
  })
}

export function delUser(data) {
  return request({
    url: 'PersonnelInfo/DeletePersonnelInfo',
    method: 'post',
    data
  })
}
//查询超过三年未参加感控培训人员
export function getPersonnelInfoByLastTraining(data) {
  return request({
    url: "PersonnelInfo/GetPersonnelInfoByLastTraining",
    method: "post",
    data,
  });
}
//匹配现患率平台医院账号
export function matchHospitalNumber(data) {
  return request({
    url: "PrevalenceRate/MatchHospitalNumber",
    method: "post",
    data,
  });
}


// WEBPACK FOOTER //
// ./src/api/user.js